import type { IPrices } from "~/libs/types/api/product"

export default (item: IPrices) => {
    if (item.user_price) {
        const tmp = useSortBy(item.user_price, ["price", "discounted_price"])
        return {
            price: tmp[0].price,
            discounted_price: tmp[0].discounted_price,
            special: true,
        }
    }
    return {
        price: item.price,
        discounted_price: item.discounted_price,
    }
}
